// extracted by mini-css-extract-plugin
export default {"list":"TaskList_list__I0HQP","listItem":"TaskList_listItem__LOPV3"};